import { render, staticRenderFns } from "./PlanejamentoMensalAEE.vue?vue&type=template&id=5b435556&scoped=true"
import script from "./PlanejamentoMensalAEE.vue?vue&type=script&lang=js"
export * from "./PlanejamentoMensalAEE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b435556",
  null
  
)

export default component.exports